import {
  Grid,
  TextField,
  Typography,
  Fade,
  Modal,
  Box,
  Backdrop,
  Button,
} from "@material-ui/core";
import useCustomState from "../../hooks/State";
import Call from "../../service/API";
import { convertNumbers } from "../../utils/ConvertNumbers";
import { ERROR_COLOR } from "../../utils/const";

import "react-modern-calendar-datepicker/lib/DatePicker.css";
import DatePicker from "react-modern-calendar-datepicker";
import "../../assets/css/calendar.css";
import { utils } from "react-modern-calendar-datepicker";
import moment from "jalali-moment";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper", //   border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const getDate = (days, prevOrNext) => {
  let date;
  if (prevOrNext == "Prev") {
    date = moment().add(-Number(days), "day");
  } else {
    date = moment().add(Number(days), "day");
  }

  date = date.locale("fa").format("YYYY/MM/DD");
  const jsonDate = {
    year: Number(date.split("/")[0]),
    month: Number(date.split("/")[1]),
    day: Number(date.split("/")[2]),
  };

  return jsonDate;
};

const showDate = (date) => {
  return date.year + "/" + date.month + "/" + date.day;
};

const ModalCounterExcel = (props) => {
  const handleClose = () => {
    props.open.handleChange(false);
  };
  const excelLink = useCustomState("");
  const excelLinkChanged = (newLink) => {
    excelLink.handleChange(newLink);
  };
  //   dates
  const startDate = useCustomState(utils("fa").getToday());
  const endDate = useCustomState(utils("fa").getToday());
  const startDateChanged = (newDate) => {
    startDate.handleChange(newDate);
  };
  const endDateChanged = (newDate) => {
    endDate.handleChange(newDate);
  };
  const startDateRenderer = ({ ref }) => (
    <TextField
      aria-readonly={true}
      ref={ref}
      value={convertNumbers(showDate(startDate.value))}
      fullWidth
      variant="standard"
      label="از تاریخ"
      InputLabelProps={{
        style: {
          fontFamily: "Vazir",
        },
      }}
      size="small"
    ></TextField>
  );
  const endDateRenderer = ({ ref }) => (
    <TextField
      aria-readonly={true}
      ref={ref}
      value={convertNumbers(showDate(endDate.value))}
      fullWidth
      variant="standard"
      label="تا تاریخ"
      InputLabelProps={{
        style: {
          fontFamily: "Vazir",
        },
      }}
      size="small"
    ></TextField>
  );
  const getExcelFile = () => {
    let utc_start_date = moment(showDate(startDate.value), "jYYYY/jM/jD")
      .locale("utc")
      .format("YYYY-MM-DDT00:00:00Z");
    let utc_end_date = moment(showDate(endDate.value), "jYYYY/jM/jD")
      .locale("utc")
      .format("YYYY-MM-DDT00:00:00Z");
    let data = {
      water_meter_serial: props.counter.water_meter_serial,
      start_time: utc_start_date,
      end_time: utc_end_date,
    };
    Call("POST", "watermeters/admin/getOne/csv", data)
      .then((response) => {
        if (response.data.code === 200) {
          let fileUrl =
            "http://217.144.106.32:6565" + response.data.data.fileurl;
          excelLinkChanged(fileUrl);
          handleClose();
          let link = document.getElementById("download-xlsx-counter");
          //   console.log(fileUrl);
          link.href = fileUrl;
          link.setAttribute("download", fileUrl);
          link.click();
        }
      })
      .catch((error) => {
        if (error.response) {
          const data = error.response.data;
          // console.log(data);
        }
      });
  };
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={props.open.value}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={props.open.value}>
        <Box sx={style} style={{ borderRadius: "8px" }}>
          <Typography id="transition-modal-title" variant="h6" component="h2">
            خروجی اکسل کنتور {props.counter.water_meter_name}
          </Typography>
          <Grid container xs={12} sm={12} md={12} lg={12}>
            <Grid
              item
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              xs={12}
              sm={12}
              md={12}
              lg={12}
            >
              <DatePicker
                value={startDate.value}
                onChange={startDateChanged}
                renderInput={startDateRenderer}
                colorPrimary="#0eca2d" // added this
                calendarClassName="custom-calendar" // and this
                calendarTodayClassName="custom-today-day" // also this
                shouldHighlightWeekends
                locale="fa"
                maximumDate={getDate(30, "Next")}
              />
              <DatePicker
                value={endDate.value}
                onChange={endDateChanged}
                renderInput={endDateRenderer}
                colorPrimary="#0eca2d" // added this
                calendarClassName="custom-calendar" // and this
                calendarTodayClassName="custom-today-day" // also this
                shouldHighlightWeekends
                locale="fa"
                maximumDate={getDate(30, "Next")}
              />
            </Grid>
            <Grid
              style={{ marginTop: "48px" }}
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
            >
              <Button
                onClick={getExcelFile}
                style={{ color: "#fff" }}
                variant="contained"
                color="primary"
              >
                دریافت اکسل
              </Button>
              <Button
                onClick={handleClose}
                style={{
                  color: "#fff",
                  marginRight: "4px",
                  backgroundColor: ERROR_COLOR,
                }}
                variant="contained"
              >
                انصراف
              </Button>
            </Grid>
            <a
              id="download-xlsx-counter"
              href="#"
              target="_blank"
              rel="noopener noreferrer"
              style={{ display: "none" }}
            ></a>
          </Grid>
        </Box>
      </Fade>
    </Modal>
  );
};
export default ModalCounterExcel;
